import type {ClassValue} from "clsx";
import cn from "@/utils/cn";

export default function Alert({severity, className, children, ...props}: {severity: "info", className?: ClassValue, children: React.ReactNode})
{
    let severityClassName;

    switch (severity)
    {
        case "info": severityClassName = "bg-blue-500"; break;
    }

    return (
        <div className={cn(className)} {...props}>
            <div className={cn("px-2.5 py-2 rounded", severityClassName)}>
                {children}
            </div>
        </div>
    );
}
